import { DialogTitle } from './DialogTitle';
import {
  StyledDialog,
  StyledDialogActions,
  StyledDialogContent,
} from './styles';
import { TDialogProps } from './types';

export const Dialog = ({
  open,
  onClose,
  children,
  additionalTitleSlot,
  title,
  leftButtonSlot,
  rightButtonSlot,
  noContentPadding = false,
  ...otherDialogProps
}: TDialogProps) => {
  return (
    <StyledDialog open={open} onClose={onClose} {...otherDialogProps}>
      <DialogTitle rightSlot={additionalTitleSlot}>{title}</DialogTitle>
      <StyledDialogContent noContentPadding={noContentPadding}>
        {children}
      </StyledDialogContent>
      <StyledDialogActions>
        {leftButtonSlot}
        {rightButtonSlot}
      </StyledDialogActions>
    </StyledDialog>
  );
};
